import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WagmiProvider } from 'wagmi';
import { ConnectKitProvider } from 'connectkit'; // eslint-disable-line
import { Toaster } from 'react-hot-toast';

import MainLayout from './layouts/MainLayout';
import AppContextProvider from './context/AppContextProvider';
import PageNotFound from './components/views/PageNotFound';
import SwapCard from './components/views/Swap';
import { config } from './config/wagmiConfig';
import Faucet from './components/views/Faucet';
import { TrackHistory } from './components/views/TrackHistory';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchOnMount: true,
    },
  },
});

// Pass client to React Context Provider
export default function App() {
  return (
    <BrowserRouter>
      <WagmiProvider config={config}>
        <QueryClientProvider client={queryClient}>
          <ConnectKitProvider>
            <AppContextProvider>
              <MainLayout>
                <Routes>
                  <Route path="/" element={<Navigate to="/swap" />} />
                  <Route path="/swap" element={<SwapCard />} />
                  <Route path="/track" element={<TrackHistory />} />
                  <Route path="/faucet" element={<Faucet />} />
                  <Route path="*" element={<PageNotFound />} />
                </Routes>
                <Toaster />
              </MainLayout>
            </AppContextProvider>
          </ConnectKitProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </BrowserRouter>
  );
}
